<div class="loginPage register">
  <h2 class="form__title">Register with XDGE!</h2>
  <p class="form__subtitle">Join now to unlock exclusive, personalized benefits!</p>
  <form [formGroup]="setupAccountForm">
    <div class="form-group">
      <label class="form__label">Phone number*</label>
      <div class="phoneNo">
        <span>+1</span>
        <input type="text" formControlName="phoneNumber" class="form__input form-control" placeholder="Enter phone number" />
      </div>
      <div *ngIf="setupAccountForm.controls['phoneNumber'].hasError('required') && showError" class="validation-error">
        *Please enter phone number.
      </div>
      <div
        *ngIf="!setupAccountForm.controls['phoneNumber'].hasError('required') && setupAccountForm.controls['phoneNumber'].invalid && showError"
        class="validation-error"
      >
        *Please enter a valid 10-digit US phone number.
      </div>
    </div>
    <div class="form-group">
      <label class="form__label">Email*</label>
      <div class="verifiedIconWrap">
        <input autocomplete="off" type="text" formControlName="email" class="form__input form-control" placeholder="Enter email" name="email" />
        <!-- <span class="verifiedIcon">Verified</span> -->
        <div *ngIf="setupAccountForm.controls['email'].hasError('required') && showError" class="validation-error">*Please enter email address.</div>
        <div
          *ngIf="!setupAccountForm.controls['email'].hasError('required') && setupAccountForm.controls['email'].invalid && showError"
          class="validation-error"
        >
          *Please enter a valid email address.
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Password*</label>
      <div class="password__box">
        <input
          [type]="isPasswordVisible ? 'text' : 'password'"
          class="form__input form-control"
          placeholder="Enter password"
          formControlName="password"
        />
        <a href="javascript:void(0)" (click)="isPasswordVisible = !isPasswordVisible" class="toggle__image">
          <!-- <img
            src="{{ isPasswordVisible ? '../../../assets/images/ic_eye_opened.svg' : '../../../assets/images/ic_eye_closed.svg' }}"
            alt="ic_eye_closed"
          /> -->
          <div *ngIf="isPasswordVisible" [innerHTML]="ICONS.eyeOpenIcon | safeHtml"></div>
          <div *ngIf="!isPasswordVisible" [innerHTML]="ICONS.eyeCloseIcon | safeHtml"></div>
        </a>
      </div>
      <div *ngIf="setupAccountForm.controls['password'].hasError('required') && showError" class="validation-error">*Please enter the password.</div>
      <div
        class="validation-error"
        *ngIf="
          (setupAccountForm.controls['password'].hasError('pattern') || setupAccountForm.controls['password'].hasError('maxlength')) && showError
        "
      >
        Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special
        character.
      </div>
    </div>
    <div class="form-group mb-24">
      <label>Confirm password*</label>
      <div class="password__box">
        <input
          [type]="isConfirmationPasswordVisible ? 'text' : 'password'"
          class="form__input form-control"
          placeholder="Enter password"
          formControlName="confirmPassword"
        />
        <a href="javascript:void(0)" (click)="isConfirmationPasswordVisible = !isConfirmationPasswordVisible" class="toggle__image">
          <!-- <img
            src="{{ isConfirmationPasswordVisible ? '../../../assets/images/ic_eye_opened.svg' : '../../../assets/images/ic_eye_closed.svg' }}"
            alt="ic_eye_closed"
          /> -->
          <div *ngIf="isConfirmationPasswordVisible" [innerHTML]="ICONS.eyeOpenIcon | safeHtml"></div>
          <div *ngIf="!isConfirmationPasswordVisible" [innerHTML]="ICONS.eyeCloseIcon | safeHtml"></div>
        </a>
      </div>
      <div *ngIf="setupAccountForm.controls['confirmPassword'].hasError('required') && showError" class="validation-error">
        *Please enter the confirm password.
      </div>
      <div
        class="validation-error"
        *ngIf="
          (setupAccountForm.controls['confirmPassword'].hasError('confirmedValidator') ||
            setupAccountForm.controls['confirmPassword'].hasError('maxlength')) &&
          showError
        "
      >
        *Passwords do not match.
      </div>
    </div>
    <div class="login__actions mb-3">
      <label class="login__remember-me all__small">
        <input type="checkbox" class="form__checkbox" formControlName="accept" name="accept" />
        I agree to the
        <a routerLink="/terms-conditions" target="_blank" class="text-red">Terms of Service</a> and
        <a routerLink="/privacy-policy" target="_blank" class="text-red">Privacy Policy</a>
      </label>
      <div
        class="validation-error"
        *ngIf="(setupAccountForm.controls['accept'].hasError('required') || setupAccountForm.value.accept == false) && showError"
      >
        *Please agree to the Terms of Service and Privacy Policy.
      </div>
    </div>
    <div class="login__actions">
      <label class="login__remember-me all__small">
        <input type="checkbox" class="form__checkbox" formControlName="accept_msg" name="accept_msg" />
        <!-- By signing up, you agree to receive SMS messages from XDGE for account verification. You will receive SMS messages for login, registration,
        and account recovery purposes. By registering, you consent to receive SMS messages (including OTPs) from XDGE -->
        I agree to receive automated transactional SMS messages from XDGE for account security purposes, including OTPs, login verification, password
        resets, and alerts. Message frequency varies. Reply STOP to opt out. Msg & data rates may apply. Consent is not required for purchase.
      </label>
      <div
        class="validation-error"
        *ngIf="(setupAccountForm.controls['accept_msg'].hasError('required') || setupAccountForm.value.accept_msg == false) && showError"
      >
        You must agree to receive SMS messages for account security.
      </div>
    </div>
    <button type="button" (click)="onSetupAccount()" class="common--button" [class.btn-loading]="isLoading">Create account</button>
  </form>
  <div class="login__link align-center d-block">
    <a routerLink="/auth/login" class="links" href="javascript:void(0)"
      >LOGIN HERE <span class="authLinkIcon" [innerHTML]="ICONS.icArrow | safeHtml"></span
    ></a>
  </div>
</div>
